import { render } from "./UserHome.vue?vue&type=template&id=65c282ba&scoped=true"
import script from "./UserHome.vue?vue&type=script&lang=js"
export * from "./UserHome.vue?vue&type=script&lang=js"

import "./UserHome.vue?vue&type=style&index=0&id=65c282ba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c282ba"],['__file',"resources/js/pages/admin/users/UserHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65c282ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65c282ba', __exports__)) {
    api.reload('65c282ba', __exports__)
  }
  
  module.hot.accept("./UserHome.vue?vue&type=template&id=65c282ba&scoped=true", () => {
    api.rerender('65c282ba', render)
  })

}


export default __exports__